'use client';
import styled from 'styled-components';

const spinnerTrackColor = (theme, variant) => {
  if (variant === 'light') {
    return 'rgba(255, 255, 255, 0.35)';
  }

  return theme?.colors?.get
    ? theme.colors.withAlpha('hero.plum', 0.25)
    : 'rgba(76, 15, 81, 0.25)';
};

const spinnerAccentColor = (theme, variant) => {
  if (variant === 'light') {
    return '#ffffff';
  }

  return theme?.colors?.get ? theme.colors.get('hero.plum') : '#4C0F51';
};

export const StyledSpinnerWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
`;

export const StyledSpinnerSvg = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
  animation: spin 2s linear infinite;

  .track {
    stroke: ${({ theme, $variant }) => spinnerTrackColor(theme, $variant)};
  }

  .arc {
    stroke: ${({ theme, $variant }) => spinnerAccentColor(theme, $variant)};
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const StyledLoadingOverlay = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const StyledLoadingOverlayContent = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  opacity: ${({ $isLoading }) => ($isLoading ? 0.5 : 1)};
`;

export const StyledLoadingOverlaySpinner = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;
